import { render } from "./BackgroundSelector.vue?vue&type=template&id=84f211e2&scoped=true"
import script from "./BackgroundSelector.vue?vue&type=script&lang=js"
export * from "./BackgroundSelector.vue?vue&type=script&lang=js"

import "./BackgroundSelector.vue?vue&type=style&index=0&id=84f211e2&lang=scss&scoped=true"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-84f211e2"]])

export default __exports__